import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#6572e4",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f48351",
      contrastText: "#ffffff",
    },
  },

  typography: {
    fontFamily: ["Poppins"],
  },
});

export default theme;
